import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/certification-icon.png'


_pushScopeId("data-v-4ec9a413")
const _hoisted_1 = {
  key: 0,
  class: "certification-bar"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "warning-icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-warning",
    style: {"color":"#ff4d4f","font-size":"20px"}
  })
], -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "certification-button" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cert-icon"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-close" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "custom-dialog-overlay"
}
const _hoisted_9 = { class: "success-dialog-header" }
const _hoisted_10 = { class: "success-dialog-title" }
const _hoisted_11 = { class: "success-dialog-body" }
const _hoisted_12 = { class: "success-dialog-footer" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CertificationDialog = _resolveComponent("CertificationDialog")!

  return false
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "message-content",
          innerHTML: _ctx.authMessageHtml
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _ctx.handleCertification,
            class: "cert-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.lang('certification.button.text')) + " ", 1),
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseBar && _ctx.handleCloseBar(...args)))
        }, _hoisted_7),
        _createVNode(_component_CertificationDialog, {
          visible: _ctx.dialogVisible,
          "authorization-required": _ctx.authorizationRequired,
          "force-corp-auth": _ctx.forceCorpAuth,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
          onSuccess: _ctx.handleCertificationSuccess,
          onClose: _ctx.handleCertificationCancel
        }, null, 8, ["visible", "authorization-required", "force-corp-auth", "onSuccess", "onClose"]),
        (_ctx.successDialogVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "custom-dialog success-dialog",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.lang('certification.success.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.lang('certification.success.content')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.handleSuccessConfirm,
                    class: "success-confirm-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.lang('certification.success.confirm')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}